import {AutoplayMenuModule} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuModule';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {IRecodeAutoPlayExtraConfig} from '@fantasmagames/slot/src/integration/RecodeIntegrator';
import {FreeRoundsScreenEvents} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenEvents';
import {IAutoplayOptions} from '@fantasmagames/slot/src/modules/autoplay/recode/RecodeGameAutoplayHandlerModule';
import {IAutoplaySettings} from '@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerModule';

export class RecodeAutoplayMenuModule extends AutoplayMenuModule {
	protected _hideUnrequiredAutoplaySettings: boolean = true;

	protected _freeRoundsAutoplayOptions: IAutoplayOptions;

	protected setupEvents(): void {
		super.setupEvents();

		this.on(FreeRoundsScreenEvents.FREE_GAMES_FINISHED, this.onFreeGamesFinished);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_POSTPONED, this.onFreeGamesPostponed);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_REJECTED, this.onFreeGamesRejected);
		this.on(FreeRoundsScreenEvents.FREE_GAME_EXPIRED, this.onFreeGamesExpired);
	}

	protected onFreeGamesFinished(): void {
		this.setupVisibleSettings();
	}

	protected onFreeGamesPostponed(): void {
		this.setupVisibleSettings();
	}

	protected onFreeGamesRejected(): void {
		this.setupVisibleSettings();
	}

	protected onFreeGamesExpired(): void {
		this.setupVisibleSettings();
	}

	protected setupVisibleSettings(autoplayData: IAutoplaySettings = this.logic.autoplayData): void {
		this.view.setupOptionsVisibility(autoplayData);

		// if (this._hideUnrequiredAutoplaySettings) {
		// 	this.view.hideAutoplaySettings(this._logic.autoplayData);
		// }
	}

	protected onInitResponse(): void {
		super.onInitResponse();

		if (this._hideUnrequiredAutoplaySettings) {
			this.view.hideAutoplaySettings(this._logic.autoplayData);
		}
	}

	protected isSingleWinLimitAvailable(): boolean {
		return this._logic.autoplayData.winLimitEnabled;
	}

	protected isWinLimitAvailable(): boolean {
		return this._logic.autoplayData.winLimitEnabled;
	}

	protected isLossLimitAvailable(): boolean {
		return this._logic.autoplayData.lossLimitEnabled;
	}

	protected isInFreeRounds(): boolean {
		return (this.logic as RecodeLogic).isInFreeRounds;
	}

	protected onAutoPlayButtonClicked(): void {
		// if (!this.isInFreeRounds() && this.regulatedMarket === 'uk') {
		// 	this.triggerBetLevelMenuAndWaitForUpdate();
		// } else {
		if (this.isInFreeRounds()) {
			this.setupVisibleSettings(this.freeRoundsAutoplayOptions);
		}
		this.showMenu();
		// }
	}

	protected validateRequirements(): void {
		if (this.isInFreeRounds()) {
			this.enableAcceptLimitsOK();
		} else {
			super.validateRequirements();
		}
	}

	protected setupRegulatedMarket(): void {
		// if (this.getAutoplayExtraData().useWagerLimitApi && this.getAutoplayExtraData().hasCustom) {
		if (this.getAutoplayExtraData().useWagerLimitApi && this.getAutoplayExtraData().alwaysDisplayCustomScreen) {
			this._regulatedMarket = 'uk';
			!__PRODUCTION__ && console.log('UK/DotCom Market');
		}
	}

	protected getAutoplayExtraData(): IRecodeAutoPlayExtraConfig {
		return (this.logic as RecodeLogic).recodeAutoplayExtraData;
	}

	public get freeRoundsAutoplayOptions(): IAutoplaySettings {
		return {
			enabled: this.logic.autoplayData.enabled,
			spinCount: this.logic.autoplayData.spinCount,
			spinDefault: this.logic.autoplayData.spinDefault,
			untilStop: false,
			maxSpinsUntilStop: NaN,
			winLimitEnabled: false,
			winLimitsAmounts: [],
			winLimitDefault: NaN,
			lossLimitEnabled: false,
			lossLimitDefault: NaN,
			lossLimitsAmounts: [],
		};
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/recode/RecodeAutoplayMenuModule.ts